import React from 'react';
import PropTypes from 'prop-types';
import FormField from '@adsk/alloy-react-form-field';
import TextInput from '@adsk/alloy-react-text-input';
import { useLocale } from '@adsk/alloy-react-locale';
import FieldWrapper from '../FieldWrapper';

const TextField = ({
  autoFocus,
  errorMessage,
  isEditing,
  onBlur,
  onChange,
  placeHolder,
  required,
  title,
  value,
}) => {
  const { T } = useLocale(({ locale }) =>
    require(`../../../../i18n/${locale}.json`)
  );
  const content = isEditing ? (
    <FormField error={errorMessage} required={required}>
      <TextInput
        error={errorMessage != null}
        type="text"
        placeholder={placeHolder}
        onChange={onChange}
        value={value ?? ''}
        autoFocus={autoFocus}
        onBlur={onBlur}
      />
    </FormField>
  ) : (
    value || T.translate('PROJECT_NOT_AVAILABLE')
  );

  return (
    <FieldWrapper isEditing={isEditing} title={title} required={required}>
      {content}
    </FieldWrapper>
  );
};

TextField.propTypes = {
  autoFocus: PropTypes.bool,
  errorMessage: PropTypes.string,
  isEditing: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  placeHolder: PropTypes.string,
  required: PropTypes.bool,
  title: PropTypes.string,
  value: PropTypes.string,
};

TextField.defaultProps = {
  autoFocus: false,
  required: false,
};

export default TextField;
